import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  initialHours?: number;
  initialMinutes?: number;
  initialSeconds?: number;
  className?: string;
  showLabels?: boolean;
}
export function CountdownTimer({
  initialHours = 0,
  initialMinutes = 47,
  initialSeconds = 23,
  className = '',
  showLabels = false
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: initialHours,
    minutes: initialMinutes,
    seconds: initialSeconds
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          // Reset to a random time between 30 and 59 minutes to maintain urgency
          return {
            hours: 0,
            minutes: Math.floor(Math.random() * 30) + 30,
            seconds: Math.floor(Math.random() * 60)
          };
        }
        let newSeconds = prev.seconds - 1;
        let newMinutes = prev.minutes;
        let newHours = prev.hours;
        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  if (showLabels) {
    return <div className={`flex items-center justify-center gap-4 ${className}`} data-id="element-64">
        <div className="flex flex-col items-center" data-id="element-65">
          <span className="text-4xl md:text-5xl font-black" data-id="element-66">
            {formatTime(timeLeft.hours)}
          </span>
          <span className="text-xs md:text-sm font-bold uppercase mt-1" data-id="element-67">
            Horas
          </span>
        </div>
        <span className="text-4xl md:text-5xl font-black mb-5" data-id="element-68">:</span>
        <div className="flex flex-col items-center" data-id="element-69">
          <span className="text-4xl md:text-5xl font-black" data-id="element-70">
            {formatTime(timeLeft.minutes)}
          </span>
          <span className="text-xs md:text-sm font-bold uppercase mt-1" data-id="element-71">
            Min
          </span>
        </div>
        <span className="text-4xl md:text-5xl font-black mb-5" data-id="element-72">:</span>
        <div className="flex flex-col items-center" data-id="element-73">
          <span className="text-4xl md:text-5xl font-black" data-id="element-74">
            {formatTime(timeLeft.seconds)}
          </span>
          <span className="text-xs md:text-sm font-bold uppercase mt-1" data-id="element-75">
            Seg
          </span>
        </div>
      </div>;
  }
  return <span className={`font-mono font-bold ${className}`} data-id="element-76">
      {formatTime(timeLeft.hours)}:{formatTime(timeLeft.minutes)}:
      {formatTime(timeLeft.seconds)}
    </span>;
}